<template>
  <div class="home-list-container d-flex flex-column">
    <div class="search media">
      <div class="media-body">
        <search-input
          :placeholder="'ค้นหาบ้านเลขที่'"
          @search="searchHome"
        ></search-input>
      </div>
      <div class="ml-3">
        <filter-dropdown
          :header="'คัดกรองสถานะ'"
          :rows="filterOptions"
          :type="'radio'"
          @filterSubmit="onFilterChange"
        ></filter-dropdown>
      </div>
    </div>
    <div class="home-list">
      <div
        active-class="active"
        v-for="home in homes"
        :key="home.id"
        class="home-item d-flex px-3 py-3"
        @click="handleSelecthome(home.id)"
      >
        <div class="flex-grow-1 flex-shrink-0">
          <div class="home-number-label mb-1">
            {{ $t("feature.member.house_number") }}
          </div>
          <h5 class="home-number">{{ home.address }}</h5>
        </div>
        <div class="flex-grow-0 flex-shrink-0 ml-1">
          <div class="member-status" :class="{ active: home.isActive }">
            <div class="label mb-1">{{ $t("feature.member.status") }}</div>
            <div class="info">
              {{
                home.isActive
                  ? $t("feature.member.active")
                  : $t("feature.member.in_active")
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="member-summary d-flex py-3 px-0 mt-auto">
      <div
        class="status-statistic d-flex flex-grow-1 px-2 justify-content-between"
      >
        <div class="">
          <span>จำนวนทั้งหมด</span>
          <h6>{{ stat.unitCount }}</h6>
        </div>
        <div class="">
          <span>เปิดใช้งานแล้ว</span>
          <h6 class="active">{{ stat.activeUnitCount }}</h6>
        </div>
      </div>
      <div class="categories px-2 flex-grow-1">
        <div class="info">
          <span>เจ้าของ</span>
          <span class="count">{{ stat.ownerCount }}</span>
          <span>คน</span>
        </div>
        <div class="info">
          <span>ผู้อยู่อาศัย</span>
          <span class="count">{{ stat.residentCount }}</span>
          <span>คน</span>
        </div>
        <div class="info">
          <span>ผู้เช่า</span>
          <span class="count">{{ stat.renterCount }}</span>
          <span>คน</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from "@/components/helper/SearchInput";
import FilterDropdown from "@/components/helper/Dropdown";
import { isEmpty } from "ramda";

export default {
  components: {
    SearchInput,
    FilterDropdown
  },
  props: ["value"],
  data() {
    return {
      filterOptions: [
        {
          key: "",
          value: "ทั้งหมด"
        },
        {
          key: "active",
          value: this.$t("feature.member.active")
        },
        {
          key: "inactive",
          value: this.$t("feature.member.in_active")
        }
      ],
      filterCategory: "",
      searchKeyword: ""
    };
  },
  computed: {
    homes() {
      const homes = !isEmpty(this.filterCategory)
        ? this.filterCategory === "active"
          ? this.value.homes.filter(home => home.isActive)
          : this.value.homes.filter(home => !home.isActive)
        : this.value.homes;

      return !isEmpty(this.searchKeyword) ? homes.filter(home => home.address.includes(this.searchKeyword)) : homes
    },
    stat() {
      const stat = this.value.stat ? this.value.stat : {};

      return stat;
    }
  },
  methods: {
    handleSelecthome(id) {
      this.$emit("selectedHome", id);
    },
    onFilterChange(category) {
      this.filterCategory = category;
    },
    searchHome(keyword) {
      this.searchKeyword = keyword;
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.home-list-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.home-list {
  overflow: auto;
}

.home-item {
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
  .home-number-label {
    font-size: 11px;
    color: #8c8786;
  }
  h5.home-number {
    color: black;
    font-size: 22px;
    font-weight: bold;
  }
  .member-status {
    border-radius: 5px;
    background-color: #f9f9f9;
    padding: 8px;
    .label {
      font-size: 11px;
    }
    .info {
      font-weight: bold;
      font-size: 14px;
      color: #8c8786;
    }
    &.active {
      .info {
        color: #00b793;
      }
    }
  }
}

.member-summary {
  border-top: 1px solid #e0e0e0;
  span {
    color: #8c8786;
    font-size: 11px;
  }
}
.status-statistic {
  border-right: solid 1px #d8d6d9;
  h6 {
    font-size: 22px;
    font-weight: bold;
    &.active {
      color: #00b793;
    }
  }
}
.categories {
  .info {
    text-align: right;
  }
  .count {
    color: black;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/residents/components/HomeList.vue